import { render, staticRenderFns } from "./TitleBar.vue?vue&type=template&id=18e6451a&scoped=true&"
import script from "./TitleBar.vue?vue&type=script&lang=js&"
export * from "./TitleBar.vue?vue&type=script&lang=js&"
import style0 from "./TitleBar.vue?vue&type=style&index=0&id=18e6451a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e6451a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18e6451a')) {
      api.createRecord('18e6451a', component.options)
    } else {
      api.reload('18e6451a', component.options)
    }
    module.hot.accept("./TitleBar.vue?vue&type=template&id=18e6451a&scoped=true&", function () {
      api.rerender('18e6451a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/peach-pear-plum/components/TitleBar.vue"
export default component.exports